import {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize/index';

const base = css<StyledProps>``;

export const web = css<StyledProps>`
  box-sizing: border-box;
  padding-top: ${ms(12)};
  ${base};
`;

export const native = css<StyledProps>`
  ${base};
  /* stylelint-disable-next-line property-no-unknown */
  text-align-vertical: top;
`;
